// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"N7-z","disabled":"O7-z","label":"P7-z"};